import React, { useEffect } from 'react';
import { useClientAuth } from '../../contexts/ClientAuthContext';

const BRAND_BLUE = '#4841F0';

const ClientLogout = () => {
  const { clientLogout } = useClientAuth();

  useEffect(() => {
    clientLogout();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ backgroundColor: 'var(--brand-light, #f5f5f5)' }}>
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 max-w-md w-full text-center">
        {/* Icon */}
        <div className="mx-auto mb-5 w-14 h-14 rounded-full flex items-center justify-center"
          style={{ background: '#eef2ff' }}>
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"
            style={{ color: BRAND_BLUE }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        {/* Wordmark */}
        <p style={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          fontSize: '1.4rem',
          color: BRAND_BLUE,
          letterSpacing: '-0.02em',
          marginBottom: '4px',
        }}>
          Satellite
        </p>

        <h1 className="text-xl font-semibold text-gray-800 mb-2">You've been signed out</h1>
        <p className="text-sm text-gray-500 leading-relaxed">
          Your session has ended. You can use the same magic link sent to your email to sign back in at any time.
        </p>

        <div className="mt-6 rounded-xl border border-gray-100 bg-gray-50 px-4 py-3">
          <p className="text-xs text-gray-500">
            Didn't save your link? Contact your Satellite Talent account manager and they'll send you a new one.
          </p>
        </div>
      </div>

      <p className="mt-6 text-xs text-gray-400">
        Powered by <span style={{ color: BRAND_BLUE, fontWeight: 600 }}>Satellite Talent</span> &middot; Recruitment Analytics Platform
      </p>
    </div>
  );
};

export default ClientLogout;
